<template>
  <v-layout row align-center justify-space-around>
    <v-flex xs12 order-lg2 id="articlesListings">
      <v-flex xs12>
        <v-btn outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToPage('first')" :disabled="page === 1" style="position: absolute; left: 5px;">
          <v-icon>first_page</v-icon>
        </v-btn>
        <v-btn outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToPage('previous')" :disabled="page === 1">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
        <v-btn class="elevation-1 noHover" style="cursor: auto" outline fab dark small color="accent lighten-2">
          <span style="color: #727272">{{ page }}</span>
        </v-btn>
        <v-btn class="elevation-1" outline fab dark small color="accent lighten-2" @click="goToPage('next')" :disabled="lastPage">
          <v-icon>keyboard_arrow_right</v-icon>
        </v-btn>
      </v-flex>
      <v-flex style="min-height: 100px" v-if="dataState === 'loading' || dataState === 'ready'" :class="dataState !== 'ready' ? 'blurClass' : ''">
        <v-flex v-if="options.layout === 'grid'" :class="dataState === 'ready' ? 'secondary' : ''">
          <v-layout row wrap pb-2>
            <v-flex class="item d-block elevation-3 white articlesListingCard" v-for="(item, index) in articles" :key="index" style="cursor: pointer; width: 19.5%; flex: none !important; margin: 0.3% 0.25% !important">
              <v-flex :key="item._url">
                <v-flex class="pb-2">
                  <v-avatar size=30 color="grey white--text" v-html="getIndex(index)">
                  </v-avatar>
                  <v-avatar size=30 class="ml-2" color="secondary">
                    <v-btn icon @click.stop="backtrack(item._id, 'article', item._date_published)">
                      <v-icon size="15">fas fa-backward</v-icon>
                    </v-btn>
                  </v-avatar>
                  <v-avatar size=30 class="ml-2" color="secondary">
                    <v-btn icon @click.stop="selectedArticle = item._id; deleteArticleConfirmationDialog = true">
                      <v-icon size="15">fas fa-trash</v-icon>
                    </v-btn>
                  </v-avatar>
                </v-flex>
                <img v-if="item._image_url" :src="item._image_url" style="max-width: 100%; max-height: 140px">
                <div v-if="!item._image_url" class="grey" style="width: 100%; height: 140px; display: flex; align-items: center; justify-content: center">
                  <v-icon dark size="80">block</v-icon>
                </div>
                <v-flex class="pa-0 ma-0 mt-2">
                  <v-flex class="pointer accent--text ma-0 pa-0">
                    <div>{{getEllipsis(item._title)}}</div>
                  </v-flex>
                  <v-flex v-html="item._domain" class="pointer caption accent--text"></v-flex>
                  <v-flex v-html="item._topic_count + ' Topics'" class="pointer caption accent--text"></v-flex>
                  <v-flex v-if="options.sortBy === '_tweeted_count'" v-html="item._tweeted_count + ' Tweets'" class="pointer caption accent--text"></v-flex>
                  <v-flex v-if="options.sortBy === '_date_published'" v-html="formatDateTime(item._date_published)" class="pointer caption accent--text"></v-flex>
                  <v-btn small outline @click="gotToArticle(item._url)">Go to article</v-btn>
                  <v-btn small outline @click="viewDetails(item)">View details</v-btn>
                </v-flex>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-list two-line class="pt-0 scroll-y" v-if="options.layout === 'tiles'">
          <v-divider></v-divider>
          <template v-for="(item, index) in articles">
            <v-list-tile
              :key="item._url"
              avatar
              class='pa-0'
              :style='index % 2 === 0 ? "background-color: #EFEFEF99" : "background-color: #FFFFFF99"'
              @click="gotToArticle(item._url)">
              <v-list-tile-avatar color="grey" tile>
                <img v-if="item._image_url" :src="item._image_url">
                <v-icon v-else dark>block</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content class='pr-4 articles'>
                <v-list-tile-title v-html="item._domain" class="pointer"></v-list-tile-title>
                <v-list-tile-sub-title class="pointer">{{ item._title.length > 140 ? item._title.slice(0,140) + '...' : item._title }}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-divider vertical></v-divider>
              <v-list-tile-content class='counters align-center' :style="options.sortBy === '_date_published' ? 'background-color: #f8a1351a' : ''">
              <v-layout row class="align-center justify-content-center">
                <v-flex sm2>
                  <v-icon small class="mr-2" color="orange lighten-2">fas fa-calendar</v-icon>
                </v-flex>
                <v-flex>
                  <v-list-tile-title>{{ formatDate(getLocalDate(item._date_published)) }}</v-list-tile-title>
                  <v-list-tile-sub-title v-html="formatTime(getLocalDate(item._date_published))"></v-list-tile-sub-title>
                </v-flex>
              </v-layout>
            </v-list-tile-content>
              <v-divider vertical></v-divider>
              <v-list-tile-content class='counters' :style="options.sortBy === '_tweeted_count' ? 'background-color: #64b5f61a' : ''">
                <v-list-tile-title class="text-md-center" style="display:flex; justify-content: center"><v-icon small left class="mr-2" color="blue lighten-2">fab fa-twitter</v-icon><p style="min-width: 60px">{{ formatNumber(item._tweeted_count) }}</p></v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-avatar @click.stop="backtrack(item._id, 'article', item._date_published)" color="secondary" size="40" class="pointer" style="margin-top:0">
                <v-btn icon class="align-center justify-content-center">
                  <v-icon>fas fa-backward</v-icon>
                </v-btn>
              </v-list-tile-avatar>
              <v-list-tile-avatar @click.stop="selectedArticle = item._id; deleteArticleConfirmationDialog = true" color="secondary" size="40" class="pointer" style="margin-top:0">
                <v-btn icon class="align-center justify-content-center">
                  <v-icon>fas fa-trash</v-icon>
                </v-btn>
              </v-list-tile-avatar>
            </v-list-tile>
          </template>
        </v-list>
      </v-flex>
      <template v-if="dataState === 'loading'">
        <center class="alternateState">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </center>
      </template>
      <template v-else-if="dataState === 'noData'">
        <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="primary--text" style="font-size: 40px !important;width:100%">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">no data found</p></div>
      </template>
      <template v-else-if="dataState === 'error'">
        <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="error--text" style="font-size: 40px !important">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
      </template>
      <v-flex xs12>
        <v-btn outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToPage('first')" :disabled="page === 1" style="position: absolute; left: 5px;">
          <v-icon>first_page</v-icon>
        </v-btn>
        <v-btn outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToPage('previous')" :disabled="page === 1">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
        <v-btn class="elevation-1 noHover" style="cursor: auto" outline fab dark small color="accent lighten-2">
          <span style="color: #727272">{{ page }}</span>
        </v-btn>
        <v-btn class="elevation-1" outline fab dark small color="accent lighten-2" @click="goToPage('next')" :disabled="lastPage">
          <v-icon>keyboard_arrow_right</v-icon>
        </v-btn>
      </v-flex>
    </v-flex>
    
    <v-dialog v-model="articleDetailsDialog" scrollable max-width="1000px" width="1000px">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Article Details</v-card-title>
        <v-card-text>
          <strong>Title:</strong><br/> {{ articleTitle }} <br/><br/>
          <strong>Topics:</strong><br/> {{ articleTopicsDelimited }} <br/><br/>
          <strong>Domain:</strong><br/> {{ articleDomain }} <br/><br/>
          <strong>URL:</strong><br/> {{ articleUrl }} <br/><br/>
          <strong>Image URL:</strong><br/> {{ articleImageUrl }} <br/><br/>
          <strong>Body:</strong><br/> {{ articleBody }} <br/><br/>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outline flat @click="articleDetailsDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteArticleConfirmationDialog"
      width="300"
    >
      <v-card class="secondary">
        <v-card-title class="headline">Delete article?</v-card-title>
        <v-card-text>
          <v-btn @click="deleteArticle" :loading="deleteLoading">Confirm</v-btn>
          <v-btn @click="deleteArticleConfirmationDialog = false; selectedArticle = null" :disabled="deleteLoading">Cancel</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<style>
  #articlesListings .v-list__tile{
    padding-right: 0
  }
  #articlesListings .v-btn:focus:before{
    background-color: white !important;
  }
  #articlesListings .v-btn--disabled{
    background-color: #e0e0e0 !important;
    border: 1px solid #727272;
    -webkit-box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)!important;
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)!important;
  }
  #articlesListings .v-btn--disabled:focus:before{
    background-color: #e0e0e0 !important;
  }
  #articlesListings .v-btn--disabled i{
    color: #727272 !important;
  }
</style>
<style scoped>
  .pointer{ cursor: pointer; }
  .articles{ width: 400px; }
  .articlesListingCard:hover{
    -webkit-box-shadow: 0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)!important;
    box-shadow: 0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)!important;
  }
  .noHover:hover{background-color: white !important}
  .noHover:hover:before{background-color: transparent !important}
  .alternateState{
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .blurClass{
    filter: blur(5px);
    -webkit-filter: blur(5px);
  }
  .counters{
    flex: none;
    width: calc(10% - 10px)
  }
</style>
<script>
import axios from 'axios'
import underscore from 'underscore'
import { mapGetters, mapMutations } from 'vuex'
import { formatTime, formatDate, formatDateTimeWithYear, getLocalDate } from '@/helpers/formatters'
import numeral from 'numeral'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dataState: 'loading',
      articles: [],
      page: 1,
      articleDetailsDialog: false,
      articleTitle: '',
      articleUrl: '',
      articleImageUrl: '',
      articleDomain: '',
      articleBody: '',
      articleTopicsDelimited: '',
      lastPage: false,
      deleteArticleConfirmationDialog: false,
      selectedArticle: null,
      deleteLoading: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('filters', ['getQuery', 'getFilters'])
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    formatDate: formatDate,
    formatTime: formatTime,
    getLocalDate: getLocalDate,
    deleteArticle () {
      this.deleteLoading = true
      axios.all([
        this.$store.dispatch('deleteArticleById', {id: this.selectedArticle, query: '?projectUuid=' + this.getFilters.projectUuid})
      ]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.selectedArticle = null
          this.deleteArticleConfirmationDialog = false
        } else {
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
        this.getData()
        this.deleteLoading = false
      })).catch((err) => {
        this.deleteLoading = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    backtrack: function (id, type, date) {
      let query = this.$route.query
      query.id = id
      query.type = type
      query.date = date
      query.connections = ['story']
      query.objects = ['article']
      this.$router.push({ path: '/backtracker', query: query })
    },
    getIndex: function (index) {
      return ((Number(this.page) - 1) * 30) + Number(index) + 1
    },
    getEllipsis: function (title) {
      if (title.length > 68) {
        return title.substr(0, 62) + '...'
      } else {
        return title
      }
    },
    formatDateTime (date) {
      return formatDateTimeWithYear(date)
    },
    formatNumber: function (value) {
      return Number(value) > 999 ? numeral(Number(value)).format('0.0a').toUpperCase() : value
    },
    gotToArticle: function (url) {
      window.open(url, '_blank')
    },
    viewDetails: function (article) {
      this.articleTitle = article._title
      this.articleDomain = article._domain
      this.articleUrl = article._url
      this.articleImageUrl = article._image_url
      this.articleDetailsDialog = true
      this.articleBody = 'Loading...'
      this.articleTopicsDelimited = article._topics_delimited
      axios.all([
        this.$store.dispatch('getArticleById', {id: article._id, query: this.getQuery({})})
      ]).then(axios.spread((r1) => {
        if (r1.data.status === 'SUCCESS') {
          this.articleBody = r1.data.payload.body
        } else {
          this.articleBody = 'Failed to load'
        }
      })).catch((err) => {
        this.articleBody = 'Failed to load'
        console.log(err)
      })
    },
    goToPage (direction) {
      var newPage = this.page
      if (direction === 'first') {
        newPage = 1
      } else if (direction === 'previous') {
        newPage--
      } else if (direction === 'next') {
        newPage++
      }
      if (newPage !== this.page) {
        this.page = newPage
        this.getData()
      }
    },
    getData: function () {
      this.dataState = 'loading'
      axios.all([
        this.$store.dispatch('getArticles', this.getQuery({ sortBy: this.options.sortBy, order: this.options.orderBy, pageSize: 30, pageNumber: this.page }))
      ]).then(axios.spread((r1) => {
        if (r1.data.status === 'SUCCESS') {
          this.articles = r1.data.payload
          if (r1.data.payload.length > 0) {
            this.dataState = 'ready'
            this.lastPage = (r1.data.payload.length < 30)
          } else {
            this.dataState = 'noData'
            this.lastPage = true
          }
        } else {
          this.dataState = 'error'
          this.lastPage = true
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.lastPage = true
        this.dataState = 'error'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (oldVal && newVal && !underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.page = 1
          this.getData()
        }
      }
    },
    options: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (oldVal && newVal && !underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.page = 1
          this.getData()
        }
      }
    }
  },
  mounted: function () {
    this.getData()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/listings/ArticlesListing.vue